import { getAuth, onAuthStateChanged } from "firebase/auth";

const providers = {
  "google.com": "google",
  "apple.com": "apple",
  "facebook.com": "facebook",
  password: "local",
};

export default defineNuxtPlugin(() => {
  const segment = useSegment();
  const sessionTracked = useSessionStorage("sessionTracked", false);
  const theme = useTheming();

  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (user && !sessionTracked.value) {
      sessionTracked.value = true;
      const providerId = auth.currentUser?.providerData?.[0]?.providerId;
      const provider = (providers[providerId as keyof typeof providers] ?? "local") as "google" | "apple" | "facebook" | "local";
      segment.identify(user.uid, { client_id: theme?.siteName.value, provider, fullName: user.displayName, email: user.email });
    }
  });
});
